import Vue from 'vue';
import PromiseDialog from './promise-dialog';

Vue.use(PromiseDialog);
